import React, { useEffect, useState } from 'react';
import Header from 'src/components/header/Header';
import PropTypes from 'prop-types';
import { Box, CssBaseline, makeStyles } from '@material-ui/core';
import { useAuth0 } from '@auth0/auth0-react';

import { WebContext } from 'src/scenes/web-context';
import { WebRoutes } from 'src/scenes/WebRoutes';
import { MaintenanceAlert } from 'src/components';
import { useUserApi } from 'src/services';
import { MainDrawer } from 'src/components';


const useStyles = makeStyles(() => ({
  container: {
    minHeight: 'calc(100vh - 97px)',
    paddingTop: '80px',
    backgroundColor: '#f4f6f6',
  },
}));

const WebContainer = () => {
  const classes = useStyles();
  const userApi = useUserApi();

  const [ webState, setWebState ] = useState({
    currentUser: {},
    currentPath: undefined,
    changeCurrentPath: currentPath => setWebState(prevState => ({ ...prevState, currentPath })),
    currentCompany: {},
  });

  const { getAccessTokenSilently, logout } = useAuth0();

  useEffect(() => {
    const fetch = async () => {

      try {
        const [ userInfoResult, token ] = await Promise.all([
          userApi.getUserInfo(),
          getAccessTokenSilently(),
        ]);
        const { companyId, companyName, permissions, ...userInfo } = userInfoResult;
        setWebState(prev => ({ ...prev, currentUser: { ...userInfo, token }, currentCompany: { companyId, companyName }, permissions }));
      } catch (e) {
        //Esto es para manejar el cambio de Auth0 Audience, ya que quedan invalidados los tokens, entonces forzamos el cierre de sesión
        if (e.httpStatus === 401) {
          logout({ logoutParams: window.location.origin });
          localStorage.clear();
        } else {
          throw e;
        }
      }

    };
    fetch();
  }, []);  //eslint-disable-line

  return (
    <WebContext.Provider value={webState}>
      <CssBaseline />
      <Header />
      <MaintenanceAlert />
      <Box className={classes.container} display="flex" justifyContent="center">
        <MainDrawer />
        <WebRoutes />
      </Box>
    </WebContext.Provider>
  );
};

WebContainer.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.any,
  theme: PropTypes.object,
};


export { WebContainer };
